<template>
  <el-dialog :title="modalInfo.title" :visible.sync="modalInfo.isShow" v-if="modalInfo.isShow" :close-on-click-modal='false' width="30%">
    <el-form :model="modalInfo.form" :rules="rules" ref="ruleForm">
      <el-form-item label="菜单名称" prop="menuName" :label-width="formLabelWidth" >
        <el-input v-model.trim="modalInfo.form.menuName"  size="small"></el-input>
      </el-form-item>
      <el-form-item label="菜单别名" prop="menuAlias" :label-width="formLabelWidth">
        <el-input v-model.trim="modalInfo.form.menuAlias" size="small"></el-input>
      </el-form-item>
      <el-form-item label="菜单图标" prop="menuIcon" :label-width="formLabelWidth">
        <el-input v-model.trim="modalInfo.form.menuIcon" ></el-input>
      </el-form-item>
       <el-form-item label="前端模块路径" prop="modulename" :label-width="formLabelWidth">
        <el-input v-model.trim="modalInfo.form.modulename" ></el-input>
      </el-form-item>
       <el-form-item label="路由连接" prop="routePath" :label-width="formLabelWidth">
        <el-input v-model.trim="modalInfo.form.routePath" ></el-input>
      </el-form-item>
      <el-form-item label="父级ID" prop="parentid" :label-width="formLabelWidth">
        <el-input v-model.trim="modalInfo.form.parentid" ></el-input>
      </el-form-item>
       <el-form-item label="排序" prop="sortNumber" :label-width="formLabelWidth">
        <el-input v-model.number="modalInfo.form.sortNumber" ></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="menuState" :label-width="formLabelWidth">
        <el-switch
          v-model="modalInfo.form.menuState"
          active-text="开" active-value="1"
          inactive-text="关" inactive-value="0"
          >
        </el-switch>
      </el-form-item>
      <el-form-item label="备注" prop="remark" :label-width="formLabelWidth">
        <el-input type="textarea" v-model.trim="modalInfo.form.remark" :autosize="{ minRows: 2, maxRows: 4}"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" class="confirm" @click="confirmClick()">确 定</el-button>
      <el-button size="small" class="cancel" @click="modalInfo.isShow = false">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {fetchGet, fetchPost} from "@/libs/reqCommon";
export default {
    name:'newAddModel',
    props:{
      modalInfo:{
          type:Object,
          default:() =>{}
      }
    },
    data(){
      return {
          formLabelWidth:"120px",
          rules: {
            menuName: [
              { required: true, message: '菜单名称不能为空', trigger: 'blur' }
            ],
            menuAlias: [
              { required: true, message: '菜单别名不能为空', trigger: 'blur' }
            ],
            menuIcon: [
              { required: true, message: '菜单图标不能为空', trigger: 'blur' }
            ],
            modulename: [
              { required: true, message: '前端模块路径不能为空', trigger: 'blur' }
            ],
            routePath: [
              { required: true, message: '路由路径不能为空', trigger: 'blur' }
            ],
            parentid: [
              { required: true, message: '菜单父级id不能为空', trigger: 'blur' }
            ],
            sortNumber: [
              { required: true, message: '排序不能为空'},
              { type: 'number', message: '排序必须为数字'}
            ],
          }
      }
    },
    methods:{
      confirmClick(){
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.reqNewAdd();
          } else {
            return false;
          }
        });
      },
      // 新增/编辑请求
      reqNewAdd(){
        let url = "/hcm/menu/Create";
        this.modalInfo.form.menuType = "ALL";
        if(this.modalInfo.title == "编辑"){
          url = "/hcm/menu/Update";
          this.modalInfo.form = {
            menuName:this.modalInfo.form.menuName,
            menuAlias: this.modalInfo.form.menuAlias,
            routePath: this.modalInfo.form.routePath,
            menuUrl: this.modalInfo.form.menuUrl,
            modulename: this.modalInfo.form.modulename,
            menuIcon: this.modalInfo.form.menuIcon,
            parentid:this.modalInfo.form.parentid,
            sortNumber:this.modalInfo.form.sortNumber,
            remark: this.modalInfo.form.remark,
            menuState: this.modalInfo.form.menuState,
            menuType: this.modalInfo.form.menuType,
            id: this.modalInfo.form.id,
          }
        }
        fetchPost(url,this.modalInfo.form).then(res =>{
          if(res.status == '10000'){
            this.$message({
              message: '操作成功！',
              type: res.message
            })
            this.modalInfo.isShow = false;
            this.$emit("reqTableData")
          }else{
            this.$message.error(res.message?res.message:'操作失败！');
          }
        })
      }
    }
}
</script>
<style lang="scss">

</style>
